import { Dispatch, SetStateAction } from 'react';

import { AsyncResult } from '#/utils/types';

import { UsernameFormState } from './username-form-context-state';
import { UsernameFormService } from './username-form-context-service';

export interface UsernameFormActions {
  readonly setUsername: (username: string) => void;
  readonly toggleIsUsernamePrivate: () => void;
  readonly submit: () => AsyncResult<void>;
}

export function createActions(
  setState: Dispatch<SetStateAction<UsernameFormState>>,
  service: UsernameFormService,
): UsernameFormActions {
  return {
    setUsername: (username: string) => {
      setState((state) => reducer.usernameChange(state, username));
    },
    toggleIsUsernamePrivate: () => {
      setState((state) => reducer.usernamePrivacyToggle(state));
    },
    submit: async () => {
      setState((state) => reducer.submit(state, true));
      const result = await service.submit();
      if (result.ok) {
        setState((state) => reducer.submitSuccess(state));
      } else {
        const reason = result.reason ?? 'Error updating account profile';
        setState((state) => reducer.submitFailure(state, reason));
      }
      return result;
    },
  };
}

export const reducer = {
  usernameChange(
    state: UsernameFormState,
    username: string,
  ): UsernameFormState {
    return {
      ...state,
      values: { ...state.values, username },
      touched: { ...state.touched, username: true },
      error: '',
    };
  },
  usernamePrivacyToggle(state: UsernameFormState): UsernameFormState {
    return {
      ...state,
      values: {
        ...state.values,
        isUsernamePrivate: !state.values.isUsernamePrivate,
      },
      touched: { ...state.touched, isUsernamePrivate: true },
    };
  },
  submit(state: UsernameFormState, isSubmitting: boolean): UsernameFormState {
    return { ...state, isSubmitting, error: '' };
  },
  submitFailure(state: UsernameFormState, error: string): UsernameFormState {
    return { ...state, isSubmitting: false, error };
  },
  submitSuccess(state: UsernameFormState): UsernameFormState {
    return { ...state, isSubmitting: false, error: '' };
  },
};
